import Vue from 'vue'
import Router from 'vue-router'
import LanguageView from '@/views/language-view'
import ClaimTypeView from '@/views/claim-type-view/claim-type-view'
import AboutView from '@/views/about-view/about-view'
import AddressView from '@/views/address-view/address-view'
import DataProtectionView from '@/views/data-protection-view/data-protection-view'
import DataPreparationView from '@/views/data-preparation-view/data-preparation-view'
import ScreensaverView from '@/views/screensaver-view/screensaver-view'
import FlightDetailsView from '@/views/flight-details-view/flight-details-view'
import AddClaimsItemView from '@/views/add-claims-item-view/add-claims-item-view'
import ReplacementItemView from '@/views/replacement-item-view/replacement-item-view'
import ClaimsItemsSummaryView from '@/views/claims-items-summary-view'
import SubmitClaimView from '@/views/submit-claim-view'
import SubmitSuccessView from '@/views/submit-success-view'
import MakeDelayedClaimView from '@/views/make-delayed-claim-view'
import ClaimStatusView from '@/views/claim-status-view/claim-status-view'
import ClaimStatusUpdateItemView from '@/views/claim-status-view/claim-status-update-item-view'
import ClaimStatusReplacementItemsView from '@/views/claim-status-view/claim-status-replacement-items-view'
// import ClaimStatusAddressConfirmView from '@/views/claim-status-view/claim-status-address-confirm-view'
import ClaimStatusMessagesView from '@/views/claim-status-view/claim-status-messages-view'
import ClaimStatusVerifyView from '@/views/claim-status-view/claim-status-verify-view'
import BoardingPassScanningView from '@/views/boarding-pass-scanning-view/boarding-pass-scanning-view'
import BoardingPassConfirmView from '@/views/boarding-pass-confirm-view/boarding-pass-confirm-view'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LanguageView',
      component: LanguageView,
      meta: {
        appTitle: 'message.appTitle'
      }
    },
    {
      path: '/data-protection',
      name: 'DataProtectionView',
      component: DataProtectionView,
      meta: {
        appTitle: 'message.appTitle'
      }
    },
    {
      path: '/boarding-pass-scan',
      name: 'BoardingPassScanningView',
      component: BoardingPassScanningView,
      meta: {
        appTitle: 'message.appTitle'
      }
    },
    {
      path: '/boarding-pass-confirm',
      name: 'BoardingPassConfirmView',
      component: BoardingPassConfirmView,
      meta: {
        appTitle: 'message.appTitle'
      }
    },
    {
      path: '/screensaver',
      name: 'ScreensaverView',
      component: ScreensaverView,
      meta: {
        screensaver: true
        // appTitle: 'message.appTitle'
      }
    },
    {
      path: '/claim-type',
      name: 'ClaimTypeView',
      component: ClaimTypeView,
      meta: {
        appTitle: 'message.claimType.title'
      }
    },
    {
      path: '/data-preparation',
      name: 'DataPreparationView',
      component: DataPreparationView,
      meta: {
        appTitle: 'message.claimType.title'
      }
    },
    {
      path: '/flight-details',
      name: 'FlightDetailsView',
      component: FlightDetailsView,
      meta: {
        appTitle: 'message.appTitle',
        currentStep: 1
      }
    },
    {
      path: '/about',
      name: 'AboutView',
      component: AboutView,
      meta: {
        appTitle: 'message.appTitle',
        currentStep: 2
      }
    },
    {
      path: '/address',
      name: 'AddressView',
      component: AddressView,
      meta: {
        appTitle: 'message.appTitle',
        currentStep: 3
      }
    },
    {
      path: '/add-claims-item/:arrayName?/:index?',
      name: 'AddClaimsItemView',
      component: AddClaimsItemView,
      props: true,
      meta: {
        appTitle: 'message.appTitle',
        currentStep: 4
      }
    },
    {
      path: '/replacement-item/:arrayName?/:index?',
      name: 'ReplacementItemView',
      component: ReplacementItemView,
      props: true,
      meta: {
        appTitle: 'message.appTitle',
        currentStep: 5
      }
    },
    {
      path: '/claims-items-summary',
      name: 'ClaimsItemsSummaryView',
      component: ClaimsItemsSummaryView,
      meta: {
        appTitle: 'message.appTitle',
        currentStep: 4
      }
    },
    {
      path: '/submit-claim',
      name: 'SubmitClaimView',
      component: SubmitClaimView,
      meta: {
        appTitle: 'message.appTitle',
        currentStep: 5
      }
    },
    {
      path: '/submit-success',
      name: 'SubmitSuccessView',
      component: SubmitSuccessView,
      meta: {
        appTitle: 'message.submitSuccess.title',
        currentStep: 5,
        successPage: true
      }
    },
    {
      path: '/make-delayed-claim',
      name: 'MakeDelayedClaimView',
      component: MakeDelayedClaimView,
      meta: {
        appTitle: 'message.makeDelayedClaim.title',
        currentStep: 5
      }
    },
    {
      path: '/claim-status/:guid?',
      name: 'ClaimStatusView',
      props: true,
      component: ClaimStatusView,
      meta: {
        appTitle: 'message.claimStatus.statusPageTitle'
      }
    },
    {
      path: '/claim-status/update-item/:guid?/:index?',
      name: 'ClaimStatusUpdateItemView',
      props: true,
      component: ClaimStatusUpdateItemView,
      meta: {
        appTitle: 'message.claimStatus.claimUpdateItemTitle'
      }
    },
    {
      path: '/claim-status/replacement-items/:guid?',
      name: 'ClaimStatusReplacementItemsView',
      props: true,
      component: ClaimStatusReplacementItemsView,
      meta: {
        appTitle: 'message.claimStatus.claimStatusUpdate'
      }
    },
    // {
    //   path: '/claim-status/confirm-address/:guid?',
    //   name: 'ClaimStatusAddressConfirmView',
    //   props: true,
    //   component: ClaimStatusAddressConfirmView,
    //   meta: {
    //     appTitle: 'message.claimStatus.claimStatusUpdate'
    //   }
    // },
    {
      path: '/claim-status/messages/:guid?',
      name: 'ClaimStatusMessagesView',
      props: true,
      component: ClaimStatusMessagesView,
      meta: {
        appTitle: 'message.claimStatus.messagesPageTitle'
      }
    },
    {
      path: '/claim-status/verify/:guid?',
      name: 'ClaimStatusVerifyView',
      component: ClaimStatusVerifyView,
      props: true,
      meta: {
        appTitle: 'message.verification.pageTitle'
      }
    }
  ],
  hashbang: false,
  mode: 'history',
  root: '/',
  saveScrollPosition: true
})
